import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { sellerLogin } from '../marketApi';

export default function SellerLogin() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ phone: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  function handleChange(e) {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!form.phone.trim() || !form.password) {
      setError('Please enter phone and password');
      return;
    }
    setError('');
    setLoading(true);
    try {
      await sellerLogin({ phone: form.phone.trim(), password: form.password });
      navigate('/seller');
    } catch (e) {
      setError(e.message || 'Login failed. Please check your credentials.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="page-container" style={{ maxWidth: 420, margin: '48px auto' }}>
      <div className="card" style={{ padding: 28 }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{ fontSize: 36, marginBottom: 8 }}>🏪</div>
          <h2 style={{ fontWeight: 800, fontSize: 22 }}>Seller Login</h2>
          <p style={{ color: 'var(--muted)', fontSize: 13, marginTop: 4 }}>
            Access your seller dashboard
          </p>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Phone Number</label>
            <input
              className="form-control"
              name="phone"
              value={form.phone}
              onChange={handleChange}
              placeholder="Registered mobile number"
              inputMode="numeric"
              maxLength={10}
              autoComplete="username"
            />
          </div>

          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              className="form-control"
              name="password"
              type="password"
              value={form.password}
              onChange={handleChange}
              placeholder="Your password"
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-full btn-lg"
            disabled={loading}
            style={{ marginTop: 8 }}
          >
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>

        <div style={{ textAlign: 'center', marginTop: 16, fontSize: 13 }}>
          New seller?{' '}
          <Link to="/seller/register" style={{ fontWeight: 600 }}>
            Register here
          </Link>
        </div>

        <div style={{ textAlign: 'center', marginTop: 8, fontSize: 13 }}>
          <Link to="/" style={{ color: 'var(--muted)' }}>
            ← Back to Marketplace
          </Link>
        </div>
      </div>
    </div>
  );
}
